<template>
  <div v-if="isOpen" class="cookie">
    <v-alert prominent type="info" color="#f06914">
      <v-row align="center">
        <v-col class="grow">
          <slot name="message">
            Diese Seite nutzt Google Analytics um uns zu helfen, diese Website
            und Ihre Erfahrung zu verbessern. Stimmen Sie dem zu?
            <a class="cookie__link" href="https://policies.google.com/privacy"
              >Privacy Policy</a
            >
            |
            <a
              class="cookie__link"
              href="https://www.hausdesstiftens.org/rechtliches/datenschutz/"
              >Datenschutz</a
            >
          </slot>
        </v-col>
        <v-col class="shrink d-flex justify-end" cols="12" md="3">
          <v-btn class="ma-2" @click="accept">{{ buttonTextAccept }}</v-btn>
          <v-btn class="ma-2" @click="deny">{{ buttonTextDeny }}</v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "CookieMessage",
  props: {
    buttonTextAccept: {
      type: String,
      default: "Annehmen"
    },
    buttonTextDeny: {
      type: String,
      default: "Ablehnen"
    },
    message: {
      type: String,
      default:
        "Diese Seite nutzt Google Analytics um uns zu helfen, diese Website und Ihre Erfahrung zu verbessern. Stimmen Sie dem zu?."
    },
    position: {
      type: String,
      default: "top"
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    containerPosition() {
      return `cookie--${this.position}`;
    }
  },
  created() {
    if (!this.getGDPR() === true) {
      this.isOpen = true;
    }
  },
  methods: {
    getGDPR() {
      if (process.browser) {
        return localStorage.getItem("GDPR:accepted", true);
      }
    },
    accept() {
      if (process.browser) {
        this.isOpen = false;
        localStorage.setItem("GDPR:accepted", true);
        window.location.reload();
      }
    },
    deny() {
      if (process.browser) {
        this.isOpen = false;
        localStorage.setItem("GDPR:accepted", false);
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.cookie
  z-index: 5000000
  position: fixed
  bottom: 0
  &__link
    color: #fff
    text-decoration: underline
    transition: all .25s
    &:hover
      text-decoration: none
</style>
